import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {StyledIcon, IconWrapper, StyledCard} from "./styled"
import Flex from "@irati/ui/src/Flex"
import {H4, Label} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Close from "@irati/ui/src/Close"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Button from "@irati/ui/src/Button"

interface Props {
  title: string
  subTitle?: string
  link?: string
  values?: object
  onClickLink?: () => void
  type: AlertTypes
  onHide?: () => void
}

export enum AlertTypes {
  warning = "warning",
  error = "error",
  info = "info",
  success = "success"
}

const Alert: FC<Props> = ({title, subTitle, link, values, onClickLink, type, onHide}) => {
  const theme = useTheme()
  const bgColor = () => {
    if (type === AlertTypes.warning) {
      return theme.colors.tertiary.y_400
    }
    if (type === AlertTypes.error) {
      return theme.colors.tertiary.r_400
    }
    if (type === AlertTypes.info) {
      return theme.colors.primary1
    }
    if (type === AlertTypes.success) {
      return theme.colors.utility.acid
    }
    return theme.colors.utility.acid
  }

  const icon = () => {
    if (type === AlertTypes.warning) {
      return IconTypes.circleAlertFill
    }
    if (type === AlertTypes.error) {
      return IconTypes.circleCrossFill
    }
    if (type === AlertTypes.info) {
      return IconTypes.circleInformation
    }
    if (type === AlertTypes.success) {
      return IconTypes.tick
    }
    return IconTypes.tick
  }

  const iconColor = () => {
    if (type === AlertTypes.warning) {
      return theme.colors.tertiary.y_400
    }
    if (type === AlertTypes.error) {
      return theme.colors.greys.white
    }
    if (type === AlertTypes.info) {
      return theme.colors.primary1
    }
    if (type === AlertTypes.success) {
      return theme.colors.utility.acid
    }
    return theme.colors.utility.acid
  }

  const textColor = () => {
    if (type === AlertTypes.warning) {
      return theme.colors.greys.black
    }
    if (type === AlertTypes.error) {
      return theme.colors.greys.white
    }
    if (type === AlertTypes.info) {
      return theme.colors.greys.white
    }
    if (type === AlertTypes.success) {
      return theme.colors.greys.black
    }
    return theme.colors.greys.black
  }

  return (
    <StyledCard bgColor={bgColor()} padding={2} marginBottom={2}>
      <Flex justifyContent="space-between" position="relative" width="100%">
        <Flex justifyContent="space-between" width="100%">
          <Flex alignItems={subTitle ? "flex-start" : "center"}>
            {type === AlertTypes.info ? (
              <IconWrapper justifyContent="center" alignItems="center" color={theme.colors.greys.white}>
                <StyledIcon icon={icon()} color={theme.colors.greys.white} bgColor={iconColor()} size={19} />
              </IconWrapper>
            ) : type === AlertTypes.warning || type === AlertTypes.error ? (
              <StyledIcon icon={icon()} color={theme.colors.utility.ink} bgColor={iconColor()} size={19} />
            ) : (
              <IconWrapper justifyContent="center" alignItems="center">
                <Icon icon={icon()} color={iconColor()} size={9} />
              </IconWrapper>
            )}
            <Flex direction="column">
              <H4 marginLeft={1} color={textColor()}>
                <FormattedMessage id={title} values={values} />
              </H4>
              {subTitle && (
                <Label small marginLeft={1} color={textColor()}>
                  <FormattedMessage id={subTitle} />
                </Label>
              )}
            </Flex>
          </Flex>
          {link && !onHide && (
            <Flex alignItems="center">
              <Button tertiary inverted={type === AlertTypes.info || type === AlertTypes.error} onClick={onClickLink}>
                <FormattedMessage id={link} />
              </Button>
            </Flex>
          )}
        </Flex>
        {onHide && (
          <Flex alignItems="flex-start" minWidth="150px" justifyContent="center">
            {link && (
              <Button small tertiary inverted={type === AlertTypes.info || type === AlertTypes.error} onClick={onClickLink}>
                <FormattedMessage id={link} />
              </Button>
            )}
            <Close onClick={onHide} color={textColor()} />
          </Flex>
        )}
      </Flex>
    </StyledCard>
  )
}

export default Alert
